const contractAndCostEn = {
  allSearchFilter: {
    searchPlaceholder: 'Search all...',
  },
  allTable: {
    amount: 'Amount',
    date: 'Date / Period',
    dealKind: 'Type',
    device: 'Device',
    software: 'Software',
    status: 'Status',
    title: 'Title',
  },
  contractPeriodFilter: {
    label: 'Contract Period',
    noResult: 'No matching period',
    options: {
      over_1y: 'Over 1 year',
      within_1m: 'Within 1 month',
      within_1y: 'Within 1 year',
      within_3m: 'Within 3 months',
      within_6m: 'Within 6 months',
    },
    searchPlaceholder: 'Search period...',
  },
  costOverview: {
    contractEvent: {
      autoRenewal: 'Auto Renewal',
      cancellationNoticeDeadline: 'Cancellation Notice Deadline',
      contractEnd: 'Contract End',
    },
    departmentOptions: {
      companyWide: 'Company-wide',
      engineering: 'Engineering',
      sales: 'Sales',
    },
    filterBar: {
      department: 'Department',
      searchPlaceholder: 'Search...',
      warningFlag: 'Warning Flag',
    },
    monthlyTable: {
      actual: 'Actual',
      billingModel: 'Billing Model',
      budget: 'Budget',
      contractRenewal: 'Contract Renewal',
      department: 'Department',
      device: 'Device',
      software: 'Software',
      total: 'Total',
      trend: 'Trend',
      unused: 'Unused',
      warningFlag: 'Warning Flag',
    },
    recommendedAction: {
      description:
        'By reviewing current contracts, you may be able to reduce monthly costs by ¥{{amount}}.',
      detailButton: 'View Details',
      title: 'Cost reduction opportunity',
    },
    statCards: {
      accumulatedSurplus: 'Accumulated Surplus Cost',
      monthOverMonth: 'MoM',
      perPersonCost: 'Per Person Cost (Company Avg.)',
      thisMonthActual: "This Month's Cost",
      thisMonthSurplus: "This Month's Surplus Cost",
    },
    summary: {
      collapse: 'Collapse summary',
      expand: 'Expand summary',
    },
    summaryChart: {
      legend: {
        actual: 'Actual',
        budget: 'Budget',
        surplus: 'Surplus Cost',
        variance: 'Variance',
      },
      title: 'Cost Trend',
    },
    table: {
      contract: 'Contract / Plan',
      contractEvent: {
        autoRenewal: 'Auto Renewal',
        cancellationNoticeDeadline: 'Cancellation Notice Deadline',
        contractEnd: 'Contract End',
      },
      device: 'Device',
      itemType: 'Item',
      rowType: {
        amount: 'Amount',
        contractEvent: 'Contract Event',
      },
      software: 'Software',
      total: 'Total',
      trend: 'Trend',
    },
    viewMode: {
      monthly: 'Monthly',
      transition: 'Transition',
    },
    warningFlag: {
      highUnused: 'High Unused',
      overBudget: 'Over Budget',
      renewalSoon: 'Renewal Soon',
    },
  },
  dealSearchFilter: {
    contractEndDate: 'Contract End Date',
    contractStartDate: 'Contract Start Date',
    device: 'Device',
    linkButton: 'Link Contract',
    searchPlaceholder: 'Search contracts...',
    showTerminated: 'Show cancelled / ended',
    software: 'Software',
    status: 'Status',
  },
  dealStatusFilter: {
    label: 'Status',
    noResult: 'No matching status',
    searchPlaceholder: 'Search status...',
  },
  dealSummary: {
    activeContracts: 'Active Contracts',
    contractsUpForRenewal: 'Contracts Up for Renewal (within 3 months)',
    devicesUnderContract: 'Devices Under Contract',
    devicesUpForRenewal: 'Devices Up for Renewal (within 3 months)',
    softwareUnderContract: 'Software Under Contract',
    softwareUpForRenewal: 'Software Up for Renewal (within 3 months)',
    yearOverYear: 'YoY',
  },
  dealTable: {
    cancellationNoticeDeadline: 'Cancellation Notice Deadline',
    contractPeriod: 'Contract Period',
    device: 'Device',
    evidence: 'Evidence',
    internalContact: 'Contract Manager',
    renewalMethod: 'Renewal Method',
    software: 'Software',
    status: 'Status',
    title: 'Title',
  },
  dealType: {
    all: 'All',
    contract: 'Contracts',
    estimate: 'Estimates',
    order: 'Orders',
    payment: 'Payments',
    vendorInvoice: 'Vendor Invoices',
  },
  editBottomSheet: {
    cancel: 'Cancel',
    editCostTitle: 'Edit Cost',
    editPaymentTitle: 'Edit Payment',
    planAdd: {
      addButtonLabel: 'Add',
      buttonLabel: 'Add plan',
      cancelButtonLabel: 'Cancel',
      dialogDescription:
        'Enter a plan name. If a plan with the same name already exists, it will be selected.',
      dialogTitle: 'Add a plan',
      inputLabel: 'Plan name',
      inputPlaceholder: 'Type plan name',
    },
    planSelect: {
      label: 'Plan',
      placeholder: 'Select a plan',
    },
    save: 'Save',
    saveCostSuccessToast: 'Cost data saved',
    saveSuccessToast: 'Payment data saved',
    table: {
      actual: 'Actual',
      planned: 'Planned',
      total: 'Total',
      unit: 'Unit: {{currency}}',
      unitPricePerUser: 'Unit Price (per user)',
      userCount: 'User Count',
      variance: 'Variance',
    },
  },
  editButton: 'Edit',
  estimateSearchFilter: {
    searchPlaceholder: 'Search estimates...',
    showRejectedExpired: 'Show rejected / expired',
    validityDate: 'Validity Date',
  },
  estimateStatus: {
    expired: 'Expired',
    finalized: 'Finalized',
    rejected: 'Rejected',
  },
  estimateTable: {
    contract: 'Contract',
    device: 'Device',
    evidence: 'Evidence',
    internalContact: 'Contract Manager',
    order: 'Order',
    software: 'Software',
    status: 'Status',
    title: 'Title',
    totalAmount: 'Total Amount',
    validityDate: 'Validity Date',
  },
  linkContractDialog: {
    contractListLabel: 'Contract list',
    noContracts: 'No matching contracts',
    noTenants: 'No tenants found',
    searchPlaceholder: 'Search by contract name...',
    step: {
      progress: 'Step {{current}} / {{total}} — {{description}}',
      selectContract: 'Select Contract',
      selectTenant: 'Select Tenant',
    },
    submit: 'Confirm',
    successToast: 'Contract linked successfully',
    title: 'Link Contract',
    unknownTenant: 'Unknown tenant',
  },
  loading: 'Loading...',
  orderSearchFilter: {
    orderDate: 'Order Date',
    searchPlaceholder: 'Search orders...',
    showCanceled: 'Show canceled',
  },
  orderStatus: {
    canceled: 'Canceled',
    draft: 'Draft',
    ordered: 'Ordered',
  },
  orderTable: {
    device: 'Device',
    estimate: 'Estimate',
    evidence: 'Evidence',
    internalContact: 'Contract Manager',
    orderDate: 'Order Date',
    software: 'Software',
    status: 'Status',
    title: 'Title',
    totalAmount: 'Total Amount',
    vendorInvoice: 'Vendor Invoice',
  },
  paymentOverview: {
    filterBar: {
      device: 'Device',
      filterButton: 'Filter',
      paymentStatus: 'Payment Status',
      searchPlaceholder: 'Search...',
      software: 'Software',
    },
    monthlyTable: {
      actual: 'Actual',
      applicablePeriod: 'Applicable Period',
      averageUnitPrice: 'Avg. Unit Price',
      billing: 'Billing',
      billingDriver: 'Billing Driver',
      billingModel: 'Billing Model',
      contract: 'Contract',
      deadline: 'Payment Deadline',
      department: 'Department',
      device: 'Device',
      forecast: 'Forecast',
      item: 'Item',
      paymentTiming: 'Payment Timing',
      quantity: 'Quantity',
      software: 'Software',
      status: 'Payment Status',
      total: 'Total',
      trend: 'Trend',
      variance: 'Variance',
      vendor: 'Vendor',
    },
    recommendedAction: {
      title: 'Recommended actions (implementation planned)',
    },
    statCards: {
      count: '{{count}} items',
      daysLater: 'in {{days}} days',
      nextPayment: 'Next Payment',
      thisMonthPayment: "This Month's Payments",
      thisYearActual: 'FY Actual',
      thisYearForecast: 'FY Forecast',
      vsForecast: 'vs Forecast',
      yearOverYear: 'YoY',
    },
    summary: {
      collapse: 'Collapse summary',
      expand: 'Expand summary',
    },
    summaryChart: {
      legend: {
        actual: 'Actual',
        planned: 'Planned',
        variance: 'Variance',
      },
      title: 'Payment Trend (chart implementation planned)',
    },
    table: {
      contract: 'Contract / Plan',
      device: 'Device',
      itemType: 'Item',
      monthlyStatus: {
        notRequired: 'Not Required',
        overdue: 'Overdue',
        paid: 'Paid',
        scheduled: 'Scheduled',
      },
      rowType: {
        amount: 'Amount',
        period: 'Period',
        status: 'Payment Status',
      },
      software: 'Software',
      total: 'Total',
      trend: 'Trend',
    },
    viewMode: {
      monthly: 'Monthly',
      transition: 'Trend',
    },
  },
  paymentSearchFilter: {
    hidePaid: 'Hide paid',
    paymentDate: 'Payment Date',
    paymentDeadline: 'Payment Deadline',
    searchPlaceholder: 'Search payments...',
  },
  paymentStatus: {
    completed: 'Completed',
    scheduled: 'Scheduled',
  },
  paymentTable: {
    device: 'Device',
    evidence: 'Evidence',
    internalContact: 'Contract Manager',
    paymentAmount: 'Payment Amount',
    paymentDeadline: 'Payment Deadline',
    software: 'Software',
    status: 'Status',
    title: 'Title',
    vendorInvoice: 'Vendor Invoice',
  },
  renewalMethod: {
    auto: 'Auto-renewal',
    manual: 'Manual renewal',
  },
  section: {
    cost: 'Cost',
    deal: 'Deal',
    payment: 'Payment',
  },
  status: {
    cancel: 'Cancelled',
    end: 'Ended',
    valid: 'Valid',
  },
  vendorInvoiceSearchFilter: {
    billingPeriod: 'Billing Period',
    hideReconciled: 'Hide reconciled',
    paymentDeadline: 'Payment Deadline',
    searchPlaceholder: 'Search vendor invoices...',
  },
  vendorInvoiceStatus: {
    completedReconciliation: 'Reconciled',
    discrepancy: 'Discrepancy',
    scheduledReconciliation: 'Scheduled',
  },
  vendorInvoiceTable: {
    billingPeriod: 'Billing Period',
    device: 'Device',
    evidence: 'Evidence',
    internalContact: 'Contract Manager',
    invoiceAmount: 'Invoice Amount',
    order: 'Order',
    payment: 'Payment',
    paymentDeadline: 'Payment Deadline',
    software: 'Software',
    status: 'Status',
    title: 'Title',
  },
  viewMode: {
    byContract: 'By Contract',
    combined: 'Combined',
  },
};

export default contractAndCostEn;
